import { TableHead } from "@/components/ui/table";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

export const SortHead = ({ k, sort, setSort, className = "", children, testid }) => {
  const active = sort.key === k;
  const Icon = !active ? ArrowUpDown : sort.dir === 1 ? ArrowUp : ArrowDown;
  return (
    <TableHead className={className}>
      <button type="button" onClick={() => setSort({ key: k, dir: active ? -sort.dir : 1 })}
        className={`inline-flex items-center gap-1 hover:text-foreground transition-colors ${active ? "text-foreground font-semibold" : ""}`} data-testid={testid || `sort-${k}`}>
        {children}<Icon className={`w-3 h-3 ${active ? "" : "opacity-40"}`} />
      </button>
    </TableHead>
  );
};

export const sortRows = (rows, sort, getters) => {
  const get = getters[sort.key];
  if (!get) return rows;
  return [...rows].sort((a, b) => {
    const va = get(a), vb = get(b);
    return sort.dir * (typeof va === "number" ? va - vb : String(va ?? "").localeCompare(String(vb ?? ""), "fr", { numeric: true, sensitivity: "base" }));
  });
};
